import { devConfig } from "@/api/apiAuth";
import { getCssVariableValue } from "@/utils/chartUtil";
import {
  getSmartLineTest,
  getFilledLineTest,
  getUtSignal2Test,
} from "@/api/apiChart.js";
import { HLCAreaSeries } from "@/plugin/hlc-area-series/hlc-area-series.js";

import { fetchUrl } from "@/utils/chart/fetch_chart_api.js";
import PmChartOptions from "@/js/chart/smart/smart_chart_options.js";

let pmChartInstance = new PmChartOptions();
export default class PmChartAPI {
  constructor() {
    this._baseUrl = devConfig.baseUrl;
    this.candleLoad = false;
    this.heikinLoad = false;
    this.candleData = null;
    this.heikinData = null;
    this.smHeikinData = null;
    this.smHeikinLength = 0;
    this.ao = null;
    this.aoHei = null;
    this.pink = null;
    this.pinkHei = null;
    this.markerSar = [];
    this.markerSignal = null;
    this.candleSignal = {
      none: null,
      trend1: null,
      trend2: null,
      all: null,
    };
    this.candleSignal2 = {
      none: null,
    };
    this.highlightMarkers = [];

    this.none = [];
    this.vol = [];
    this.du = [];
    this.voldu = [];
    this.noneFiltered = [];
    this.volFiltered = [];
    this.duFiltered = [];
    this.volduFiltered = [];
    this.ma1 = null;
    this.ma2 = null;
    this.ma3 = null;
    this.ma1Hei = null;
    this.ma2Hei = null;
    this.ma3Hei = null;
    this.upper = null;
    this.lower = null;
    this.upperHei = null;
    this.lowerHei = null;
    this.trend_upper = null;
    this.trend_middle = null;
    this.trend_lower = null;
    this.trend_upper52 = null;
    this.trend_middle52 = null;
    this.trend_lower52 = null;
    this.trend_upper100 = null;
    this.trend_middle100 = null;
    this.trend_lower100 = null;
    this.priceLines = {};
    this.priceLinesData = null;
    this.orange_line = null;
    this.blue_line = null;
    this.macd = null;
    this.orange_lineHei = null;
    this.blue_lineHei = null;
    this.macdHei = null;
    this.rsi = null;
    this.rsiHei = null;
    this.rsiPriceLine = {
      rsiPrice30: null,
      rsiPrice50: null,
      rsiPrice70: null,
    };
    this.senkoua = null;
    this.trend_market = null;
    this.trend_quick = null;
    this.trend_all = null;
    this.trend_hei = null;
    this.lineDataMap = {}; // kind별 lineData 저장
    this.filledDataMap = {}; // kind별 filledData 저장
    this.upper_lower = [];
    this.middle = [];
    this.filled = [];
    this.fetchData = false;
    this.aoPriceLine = null;
    this.signalInterval = null;
    this.candleSignalCache = {
      smPro: {
        candleSignal: {},
        candleSignal2: {},
      },
      smLite: {
        candleSignal: {},
      },
      highlightMarkers: {},
    };
    this.utCachedSignal = null;
  }

  getHeikinColor(colorNum) {
    return colorNum == 1 ? "#71c3ff" : getCssVariableValue("--chart-red");
  }

  // async getCandle(
  //   kind,
  //   series,
  //   isHeikin,
  //   forceUpdate = false
  // ) {
  //   // let coinType = clientCountry == 'JP' ? 'spot' : 'candle'

  //   let transformUrl = isHeikin
  //     ? `/${coinType}/heikin-candle`
  //     : `/${coinType}/candle`;

  //   let isCandleLoad = await this.isCandleLoad(isHeikin);
  //   if (
  //     isCandleLoad ||
  //     (isHeikin && !this.heikinData) ||
  //     (!isHeikin && !this.candleData)
  //   ) {
  //     let data = await fetchUrl(transformUrl, kind);

  //     const candleData = data.map(({ time, open, high, low, close }) => ({
  //       time,
  //       open,
  //       high,
  //       low,
  //       close,
  //     }));
  //     let pinkData = data.map(({ time, pink: value }) => ({ time, value }));
  //     let aoData = this.caculateAO(candleData);

  //     series.setData(candleData);
  //     if (isHeikin) {
  //       this.heikinData = candleData;
  //       this.pinkHei = pinkData;
  //       this.aoHei = aoData;
  //     } else {
  //       this.candleData = candleData;
  //       this.pink = pinkData;
  //       this.ao = aoData;
  //     }
  //   } else {
  //     if (isHeikin) {
  //       series.setData(this.heikinData);
  //     } else if (smIsHeikin) {
  //       if (!this.smHeikinData || forceUpdate) {
  //         this.smHeikinData = await fetchUrl("/candle/custom-heikin", kind);
  //       }

  //       const smHeiCandleData = this.smHeikinData.map(
  //         ({ time, open, high, low, close, color }) => ({
  //           time,
  //           open,
  //           high,
  //           low,
  //           close,
  //           color: this.getHeikinColor(color),
  //           wickColor: this.getHeikinColor(color),
  //           borderColor: this.getHeikinColor(color),
  //         })
  //       );
  //       // let pinkData = this.smHeikinData.map(({ time, pink: value }) => ({
  //       //   time,
  //       //   value,
  //       // }));

  //       smHeiCandleData[smHeiCandleData.length - 1].color = "rgba(0, 0, 0, 0)";

  //       // this.smHeikinData = smHeiCandleData;
  //       this.smHeikinLength = smHeiCandleData.length;
  //       // this.pink = pinkData;
  //       series.setData(smHeiCandleData);
  //     } else {
  //       series.setData(this.candleData);
  //     }
  //   }
  // }

  async getCandle(kind, series, isHeikin) {
    let transformUrl = isHeikin ? `/candle/custom-heikin` : `/candle/candle`;
    // let transformUrl = isHeikin ? `/candle/heikin-candle`  : `/candle/candle`
    let isCandleLoad = await this.isCandleLoad(isHeikin);
    if (
      isCandleLoad ||
      (isHeikin && !this.heikinData) ||
      (!isHeikin && !this.candleData)
    ) {
      let data = await fetchUrl(transformUrl, kind);
      let candleData, pinkData;
      if (isHeikin) {
        candleData = data.map(({ time, open, high, low, close, color }) => ({
          time,
          open,
          high,
          low,
          close,
          color: this.getHeikinColor(color),
          wickColor: this.getHeikinColor(color),
          borderColor: this.getHeikinColor(color),
        }));
        // candleData = data.map( ({time,open,high,low,close}) => (
        //     { time,open,high,low,close }
        // ))
        candleData[candleData.length - 1].color = "rgba(0, 0, 0, 0)";

        this.heikinData = candleData;
        this.heikinLength = candleData.length;
        // console.log('candleData.length',candleData.length);
      } else {
        candleData = data.map(({ time, open, high, low, close }) => ({
          time,
          open,
          high,
          low,
          close,
        }));
        pinkData = data.map(({ time, pink: value }) => ({ time, value }));
        let aoData = this.caculateAO(candleData);
        // console.log('aoData',aoData);

        // console.log('origin',candleData,candleData.length);
        if (candleData.length > this.heikinLength) {
          // console.log('candle more than smart');

          let needSlice = candleData.length - this.heikinLength;
          candleData.splice(0, needSlice);
          pinkData.splice(0, needSlice);
          aoData.splice(0, needSlice);
          this.firstCandleTime = candleData[0].time;
        }
        // console.log(candleData,candleData.length);

        this.candleData = candleData;
        this.pink = pinkData;
        this.ao = aoData;
        // console.log('this.ao',this.ao);
      }
      series.setData(candleData);
    } else {
      if (isHeikin) {
        series.setData(this.heikinData);
      } else {
        // console.log('this.candleData',this.candleData);
        series.setData(this.candleData);
      }
    }
  }

  async getIndicator(kind, isHeikin, chartObj) {
    let { url, series, key } = chartObj;

    if (key == "SMARTCHANNEL") {
      key = "PINK";
    }

    let initLoad = await this.isInitLoad(series, isHeikin, key);
    if (initLoad) {
      let transformUrl = this.setRequestUrl(isHeikin, key, url);
      let data = await fetchUrl(transformUrl, kind);

      let filedGroup = Object.keys(data[0]);

      filedGroup = filedGroup.filter((filed) => filed != "time");

      filedGroup.forEach((filed, index) => {
        let result = data.map(({ time, [filed]: value }) => ({ time, value }));
        if (isHeikin) {
          this[filed + "Hei"] = this[filed + "Hei"];
          this[filed + "Hei"] = result;
        } else {
          this[filed] = result;
        }
        series[index].name.setData(result);
      });
    } else {
      await this.getSeiresData(series, isHeikin, key);
      if (key == "AO") {
        this.aoPriceLine = pmChartInstance.getAOPriceLine();
        series[0].name.createPriceLine(this.aoPriceLine);
      }
    }
  }
  async getTrendLine(kind, chartObj) {
    let { url, series, key } = chartObj;

    let initLoad = await this.isInitLoad(series, false, key);
    if (initLoad) {
      let data = await fetchUrl(url, kind);
      series.forEach((filed) => {
        if (filed.value == "52") {
          // filed.name.setData(data["52"][filed.key]);
          let convertedData = data["52"][filed.key].map((item) => ({
            time: item.time,
            value: parseFloat(item.value), //  숫자로 변환
          }));
          filed.name.setData(convertedData);
          // console.log("data['52'][filed.key]",data['52'][filed.key]);

          this["trend_" + filed.key + "52"] = convertedData;
        } else if (filed.value == "100") {
          // filed.name.setData(data["100"][filed.key]);
          // this["trend_" + filed.key + "100"] = data["100"][filed.key];
          let convertedData = data["100"][filed.key].map((item) => ({
            time: item.time,
            value: parseFloat(item.value), //  숫자로 변환
          }));
          filed.name.setData(convertedData);
          this["trend_" + filed.key + "100"] = convertedData;
        }
      });
    } else {
      await this.getSeiresData(series, false, key);
    }
  }
  async getSr(url, kind, container, checked) {
    if (Object.keys(this.priceLines).length > 0) {
      for (let key of Object.keys(this.priceLines)) {
        container.removePriceLine(this.priceLines[key]);
        delete this.priceLines[key];
      }
    }
    if (checked) {
      if (this.priceLinesData == null) {
        let data = await fetchUrl(url, kind);
        this.priceLinesData = data;
        // console.log('data',data);
      }
      for (let key of Object.keys(this.priceLinesData)) {
        this.priceLines[key + "lines"] = container.createPriceLine({
          price: this.priceLinesData[key],
          color: this.setPriceConfig(key).color,
          lineWidth: 2,
          lineStyle: 2, // LineStyle.Dashed
          axisLabelVisible: true,
          title: this.setPriceConfig(key).title,
        });
      }
    }
  }
  async getMACD(kind, isHeikin, chartObj, forRsi = false) {
    let { url, series, key } = chartObj;
    let initLoad = await this.isInitLoad(series, isHeikin, key);
    // console.log('initLoad',initLoad,'macd',this.macd,'hei',this.macdHei);

    if (initLoad) {
      let transformUrl = this.setRequestUrl(isHeikin, key, url);
      let data = await fetchUrl(transformUrl, kind);
      // console.log('data',data);

      let filedGroup = Object.keys(data[0]);
      filedGroup = filedGroup.filter(
        (filed) => filed != "time" && filed != "macd_color"
      );
      filedGroup.forEach((filed, index) => {
        let result;
        if (filed == "macd") {
          result = data.map(({ time, macd_color, macd }) => ({
            time,
            color: this.getHistogramColor(macd, macd_color),
            value: macd,
          }));
        } else {
          result = data.map(({ time, [filed]: value }) => ({ time, value }));
        }
        if (isHeikin) {
          this[filed + "Hei"] = this[filed + "Hei"];
          this[filed + "Hei"] = result;
        } else {
          this[filed] = result;
        }
        if (!forRsi) {
          series[index].name.setData(result);
        }
      });
    } else {
      await this.getSeiresData(series, isHeikin, key);
    }
  }
  async getRSI(kind, isHeikin, chartObj) {
    let { url, series, key } = chartObj;
    let initLoad = await this.isInitLoad(series, isHeikin, key);
    let RSIline = series[0].name;
    if (initLoad) {
      let transformUrl = this.setRequestUrl(isHeikin, key, url);

      let data = await fetchUrl(transformUrl, kind);
      if (isHeikin) {
        series.forEach((filed) => {
          // console.log("filed['key']",filed['key'],'this.blue_lineHei',this.blue_lineHei);
          if (filed["key"] == "rsi") {
            let result = data.map(({ time, heikin }) => ({
              time,
              value: parseFloat(heikin),
            }));
            filed.name.setData(result);
            this[filed.key + "Hei"] = result;
          } else {
            filed.name.setData(this[filed["key"] + "Hei"]);
          }
        });
      } else {
        series.forEach((filed) => {
          // console.log("filed['key']",filed['key']);

          if (filed["key"] == "rsi") {
            let result = data.map(({ time, candle }) => ({
              time,
              value: parseFloat(candle),
            }));
            filed.name.setData(result);
            this[filed["key"]] = result;
          } else {
            filed.name.setData(this[filed["key"]]);
          }
        });
      }
    } else {
      await this.getSeiresData(series, isHeikin, key);
    }
    if (Object.keys(this.rsiPriceLine).length > 0) {
      for (let key of Object.keys(this.rsiPriceLine)) {
        let RSIline = series[0].name;
        // console.log('key',key,'this.rsiPriceLine',this.rsiPriceLine,this.rsiPriceLine[key],'RSIline',RSIline);
        if (this.rsiPriceLine[key]) {
          RSIline.removePriceLine(this.rsiPriceLine[key]);
          delete this.rsiPriceLine[key];
          // console.log('reset indicator rsi',this.rsiPriceLine);
        }
      }
    }
    let priceList = ["rsiPrice30", "rsiPrice50", "rsiPrice70"];
    for (let i = 0; i < priceList.length; i++) {
      let rsiPriceLineOption = await pmChartInstance.getRSIPriceLine(
        priceList[i]
      );
      // console.log('rsiPriceLineOption',rsiPriceLineOption);

      if (rsiPriceLineOption) {
        this.rsiPriceLine[priceList[i]] = await RSIline.createPriceLine(
          rsiPriceLineOption
        );
      } else {
        // console.log("rsi price line 생성 실패");
      }
    }
  }

  async resetIndicator(series) {
    series.forEach((filed, index) => {
      filed.name.setData([]);
    });
    if (series[0].key == "rsi") {
      // rsi priceline 30,50,70 delete
      if (Object.keys(this.rsiPriceLine).length > 0) {
        for (let key of Object.keys(this.rsiPriceLine)) {
          let RSIline = series[0].name;
          if (this.rsiPriceLine[key]) {
            RSIline.removePriceLine(this.rsiPriceLine[key]);
            delete this.rsiPriceLine[key];
            // console.log('reset indicator rsi',this.rsiPriceLine);
          }
        }
      }
    }
  }
  async updateChart(fetchList) {
    // 각 fetchllist 데이터 초기화
    this.candleData = null;
    this.heikinData = null;
    this.priceLinesData = null;
    this.markerSar = [];
    this.none = [];
    fetchList.forEach(async (ob) => {
      if (ob.series && ob.series.length > 0) {
        await this.resetIndicatorData(ob.series, ob.key);
      }
    });
  }
  async resetIndicatorData(series, key) {
    series.forEach((filed) => {
      if (key == "TREND") {
        this["trend_" + filed["key"]] = null;
      } else if (key == "VOLV") {
        if (filed.value == "52") {
          this["trend_" + filed["key"] + "52"] = null;
        } else {
          this["trend_" + filed["key"] + "100"] = null;
        }
      } else {
        this[filed["key"]] = null;
        this[filed["key"] + "Hei"] = null;
        // console.log(filed['key'],this[filed['key']]);
      }
    });
  }
  async isInitLoad(series, isHeikin, key) {
    // console.log('series',series,'key',key);
    return series.some((filed) => {
      // some => 조건 하나라도 충족시 true , 아니면 false 반환하고 중단됨
      // console.log('key',key);

      if (isHeikin) {
        // console.log("this[filed[key]+'Hei']",this[filed['key']+'Hei']);
        return this[filed["key"] + "Hei"] == null;
      } else {
        if (key == "TREND") {
          return this["trend_" + filed["key"]] == null;
        } else if (key == "VOLV") {
          // console.log("this['trend_'+filed['key']+'52'] ",this['trend_'+filed['key']+'52'],'trend_'+filed['key']+'52' );

          return this["trend_" + filed["key"] + "52"] == null;
        } else {
          // console.log("filed['key']",filed['key']);
          return this[filed["key"]] == null;
        }
      }
    });
  }
  async getSeiresData(series, isHeikin, key = "") {
    if (isHeikin) {
      return series.forEach((filed) => {
        // console.log(filed['key']+"Hei");
        filed.name.setData(this[filed["key"] + "Hei"]);
      });
    } else {
      return series.forEach((filed) => {
        if (key == "VOLV") {
          if (filed.value == "52") {
            filed.name.setData(this["trend_" + filed["key"] + "52"]);
          } else {
            filed.name.setData(this["trend_" + filed["key"] + "100"]);
          }
        } else {
          filed.name.setData(this[filed["key"]]);
        }
      });
    }
  }
  async isCandleLoad(isHeikin) {
    if (isHeikin) {
      return this.heikinData === null;
    } else {
      return this.candleData === null;
    }
  }
  setRequestUrl(isHeikin, key, url) {
    if (key == "PINK") {
      return;
    } else if (
      key == "VOLV" ||
      key == "SR" ||
      key == "DU" ||
      key == "RSI" ||
      key == "SMART" ||
      key == "TREND" ||
      key == "CANDLE"
    ) {
      // console.log(11, key);

      return url;
    } else {
      const coinType = "candle";
      let baseUrl = isHeikin ? `/${coinType}/heikin-` : `/${coinType}/candle-`;
      let requestUrl = `${baseUrl}${url}`;
      return requestUrl;
    }
  }
  setPriceConfig(key) {
    let color;
    let title;
    color = key.startsWith("h") ? "#C11C1C" : "#00890E";

    if (key.endsWith("1d")) {
      title = key.startsWith("h") ? "RES1" : "SUP1";
    } else if (key.endsWith("2d")) {
      title = key.startsWith("h") ? "RES2" : "SUP2";
    } else if (key.endsWith("1w")) {
      title = key.startsWith("h") ? "RES3" : "SUP3";
    } else if (key.endsWith("2w")) {
      title = key.startsWith("h") ? "RES4" : "SUP4";
    } else if (key.endsWith("3w")) {
      title = key.startsWith("h") ? "RES5" : "SUP5";
    } else if (key.endsWith("4w")) {
      title = key.startsWith("h") ? "RES6" : "SUP6";
    }

    return { color, title };
  }
  getHistogramColor(value, status) {
    if (value >= 0 && status == "UP") {
      return "#22AB94";
    } else if (value >= 0 && status == "DOWN") {
      return "#ACE5DC";
    } else if (value < 0 && status == "UP") {
      return "#FF5252";
    } else if (value < 0 && status == "DOWN") {
      return "#FCCBCD";
    }
  }
  caculateAO(candleData) {
    let data = [];
    for (let i = 0; i < candleData.length; i++) {
      if (candleData[i].open != "") {
        let sma5 = 0,
          sma34 = 0;

        // 5일 이동 평균 계산 (데이터가 부족한 경우, 가능한 범위 내에서 계산)
        let start = Math.max(0, i - 4); // 시작 인덱스가 음수가 되지 않도록 함
        for (let j = start; j <= i; j++) {
          sma5 += candleData[j].open;
        }
        sma5 /= i - start + 1; // 유효한 데이터 개수로 나눔

        // 34일 이동 평균 계산 (데이터가 부족한 경우, 가능한 범위 내에서 계산)
        let start34 = Math.max(0, i - 33);
        for (let j = start34; j <= i; j++) {
          sma34 += candleData[j].open;
        }
        sma34 /= i - start34 + 1; // 유효한 데이터 개수로 나눔

        let ao = sma5 - sma34;
        let time = candleData[i].time;

        data.push({ time: time, value: ao });
      }
    }
    // console.log('data',data);

    return data;
  }
  async getMarkers(kind, markerSeries) {
    let series = markerSeries["series"][0]["name"];
    if (this.markerSar.length < 1) {
      this.markerSar = [];
      let data = await fetchUrl(`/analysis/rsi`, kind);
      for (let i = 0; i < data.length; i++) {
        var sarTime = data[i].time;
        if (data[i].signal == "L") {
          this.markerSar.push({
            time: sarTime,
            position: "aboveBar",
            color: "#00890E",
            shape: "circle",
            text: `${data[i].signal}`,
            id: "sar_green",
            size: 1.5,
          });
        } else if (data[i].signal == "S") {
          this.markerSar.push({
            time: sarTime,
            position: "aboveBar",
            color: "#C11C1C",
            shape: "circle",
            text: `${data[i].signal}`,
            id: "sar_red",
            size: 1.5,
          });
        }
      }
    }
    series.setMarkers(this.markerSar);
  }

  async getCandleMarkers(
    kind,
    chart,
    container,
    checkedList,
    tab,
    forceUpdate = false
  ) {
    if (!this.candleSignalCache) this.candleSignalCache = {};
    if (!this.candleSignalCache[tab]) {
      this.candleSignalCache[tab] =
        tab === "pro"
          ? { candleSignal: {}, candleSignal2: {}, highlightMarkers: [] }
          : { candleSignal: {} };
    }

    const cache = this.candleSignalCache[tab];
    const signalKey = "none";

    if (Object.keys(cache.candleSignal).length === 0 || forceUpdate) {
      // const data = await fetchUrl("/analysis/ut-signal", kind);

      //ut-signal 한번만 로드되도록
      let data;
      if (!this.utCachedSignal || forceUpdate) {
        data = await fetchUrl("/analysis/ut-signal", kind);
        this.utCachedSignal = data;
      } else {
        data = this.utCachedSignal;
      }

      if (tab === "pro") {
        const data2 = await fetchUrl("/analysis/ut-signal2", kind);
        const allKeys = [
          ...new Set([...Object.keys(data), ...Object.keys(data2)]),
        ];

        for (const key of allKeys) {
          cache.candleSignal[key] = [];
          cache.candleSignal[key + "L"] = [];
          cache.candleSignal[key + "S"] = [];
          cache.candleSignal2[key] = [];
          cache.candleSignal2[key + "L"] = [];
          cache.candleSignal2[key + "S"] = [];

          // ut-signal 처리
          if (data[key]) {
            for (const { time, signal } of data[key]) {
              const marker = {
                time,
                position: signal === "L" ? "belowBar" : "aboveBar",
                color: signal === "L" ? "#7DCD5D" : "red",
                text: signal === "L" ? "▲" : "▼",
                id: signal === "L" ? "sar_green" : "sar_red",
                size: 1,
                isToggled: false,
              };
              cache.candleSignal[key + signal].push(marker);
              cache.candleSignal[key].push(marker);
            }
          }

          // ut-signal2 처리
          if (data2[key]) {
            for (const { time, signal } of data2[key]) {
              const baseMarker = {
                time,
                position: signal === "L" ? "belowBar" : "aboveBar",
                color: signal === "L" ? "#7DCD5D" : "red",
                shape: signal === "L" ? "arrowUp" : "arrowDown",
                text: `${signal}${signal}`,
                id: signal === "L" ? "sar_green" : "sar_red",
                size: 1.5,
                isToggled: false,
              };

              const highlightMarker = {
                ...baseMarker,
                size: 1,
                shape: "circle",
                text: "",
                isToggled: true,
              };

              cache.candleSignal2[key + signal].push(
                baseMarker,
                highlightMarker
              );
              cache.candleSignal2[key].push(baseMarker, highlightMarker);
              // cache.highlightMarkers.push(highlightMarker);
              if (!cache.highlightMarkers) cache.highlightMarkers = [];
              cache.highlightMarkers.push(highlightMarker);
            }
          }
        }
      }

      if (tab === "lite") {
        for (const key of Object.keys(data)) {
          cache.candleSignal[key] = [];
          cache.candleSignal[key + "L"] = [];
          cache.candleSignal[key + "S"] = [];

          for (const { time, signal } of data[key]) {
            const marker = {
              time,
              position: signal === "L" ? "belowBar" : "aboveBar",
              color: signal === "L" ? "#00890E" : "#C11C1C",
              shape: signal === "L" ? "arrowUp" : "arrowDown",
              text: signal,
              id: signal === "L" ? "sar_green" : "sar_red",
              size: 1.5,
            };
            cache.candleSignal[key + signal].push(marker);
            cache.candleSignal[key].push(marker);
          }
        }
      }
    }

    // 마커 통합 및 정렬
    const merged =
      tab === "pro"
        ? [
            ...(cache.candleSignal[signalKey] || []),
            ...(cache.candleSignal2[signalKey] || []),
          ]
        : [...(cache.candleSignal[signalKey] || [])];

    merged.sort((a, b) => a.time - b.time);
    container.setMarkers(merged);
    await this.toggleSignalMarkers(container, merged);
  }

  async setSignalMarkers(array, marker) {
    for (let i = 0; i < array.length; i++) {
      let signal = array[i].signal;
      let timestamp = array[i].time;
      let firstChar = signal.charAt(0);
      let secondChar = signal.charAt(1);
      let lastTwoChars = signal.slice(-2);
      // console.log('signal',signal,'secondChar',secondChar);
      if (firstChar == "L") {
        if (secondChar == "V") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "orange",
            shape: "arrowUp",
            text: "🚀",
            size: 1.5,
          });
        } else if (secondChar == "B") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "orange",
            shape: "arrowUp",
            text: signal,
            size: 1.5,
          });
        } else if (secondChar == "D") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "orange",
            // shape: 'arrowUp',
            text: `▲${signal}`,
            size: 1,
          });
        } else if (secondChar == "") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "orange",
            // shape: 'arrowUp',
            text: `▲`,
            size: 1,
          });
        } else {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "orange",
            shape: "arrowUp",
            text: signal,
            size: 1.5,
          });
        }
      } else if (firstChar == "S") {
        //S
        if (secondChar == "V") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "orange",
            shape: "arrowDown",
            text: "🚀",
            size: 1.5,
          });
        } else if (secondChar == "B") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "orange",
            shape: "arrowDown",
            text: signal,
            size: 1.5,
          });
        } else if (secondChar == "D") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "orange ",
            // shape: 'arrowDown',
            text: `▼${signal}`,
            size: 1,
          });
        } else if (secondChar == "") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "orange ",
            // shape: 'arrowDown',
            text: `▼`,
            size: 1,
          });
        } else {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "orange",
            shape: "arrowDown",
            text: signal,
            size: 1.5,
          });
        }
      }
    }
    return marker.filter((item) => !/\d$/.test(item.text));
  }
  async setSignal2Markers(array, marker) {
    for (let i = 0; i < array[0].length; i++) {
      let signal = array[0][i].signal;

      let timestamp = array[0][i].time;
      let firstChar = signal.charAt(0);
      let secondChar = signal.charAt(1);

      if (firstChar == "L") {
        if (secondChar == "V") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            shape: "arrowUp",
            text: "🚀",
            size: 1.5,
          });
        } else if (secondChar == "B") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            shape: "arrowUp",
            text: signal,
            size: 1.5,
          });
        } else if (secondChar == "D") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            // shape: 'arrowUp',
            text: `▲${signal}`,
            size: 1,
          });
        } else if (secondChar == "") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            shape: "arrowUp",
            text: `L${signal}`,
            size: 2,
          });
        } else {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            shape: "arrowUp",
            text: `L${signal}`,
            size: 1.5,
          });
        }
      } else if (firstChar == "S") {
        //S
        if (secondChar == "V") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#e91e63",
            shape: "arrowDown",
            text: "🚀",
            size: 1.5,
          });
        } else if (secondChar == "B") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#E00094",
            shape: "arrowDown",
            text: signal,
            size: 1.5,
          });
        } else if (secondChar == "D") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#C11C1C ",
            // shape: 'arrowDown',
            text: `▼${signal}`,
            size: 1,
          });
        } else if (secondChar == "") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "red",
            shape: "arrowDown",
            text: `S${signal}`,
            size: 2,
          });
        } else {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#FFF100",
            shape: "arrowDown",
            text: `S${signal}`,
            size: 1.5,
          });
        }
      }
    }
    return marker.filter((item) => !/\d$/.test(item.text));
  }

  async toggleSignalMarkers(candleStickSeries, mergedMarkers) {
    if (this.signalInterval) {
      clearInterval(this.signalInterval); // 기존 인터벌 제거
    }

    let markersVisible = true;

    this.signalInterval = setInterval(() => {
      markersVisible = !markersVisible;

      candleStickSeries.setMarkers(
        mergedMarkers.map((marker) => ({
          ...marker,
          color: marker.isToggled
            ? markersVisible
              ? marker.color
              : "transparent"
            : marker.color,
          text: marker.isToggled
            ? markersVisible
              ? marker.text
              : ""
            : marker.text,
        }))
      );
    }, 500); // 500ms 간격
  }

  async toggleMarkers(original, filtered, chart, container) {
    let animationSignal = false;
    // console.log('original',original,'filtered',filtered);
    if (window.signalCandleMarkerInterval) {
      clearInterval(window.signalCandleMarkerInterval);
    } // 기존 인터벌을 정리
    window.signalCandleMarkerInterval = setInterval(function () {
      // console.log('original',original.length,'fitered',filtered.length);
      // console.log('candlestickSeries markers',candlestickSeries.markers().length);
      if (animationSignal) {
        container.setMarkers(filtered);
      } else {
        // 숫자만 나옴
        container.setMarkers(original); // noneArray로 마커 설정
      }
      animationSignal = !animationSignal; // 토글 상태 전환
      chart.priceScale("right").applyOptions({
        autoScale: false,
        scaleMargins: {
          top: 0.2,
          bottom: 0.3,
        },
      });
      // console.log(chart.priceScale('right').options());
    }, 1000);
  }
  setPriceScale(checkedList, priceScaleObj, chartContainer) {
    let rsiChecked = checkedList.includes("RSI");
    let macdChecked = checkedList.includes("MACD");
    let applyPriceScale = (
      seriesList,
      scaleId,
      top,
      bottom,
      rsiTop,
      rsiBottom
    ) => {
      seriesList.forEach((series) => {
        if (series["key"] == "rsi") {
          this.priceScaleMethod(series["name"], "rsi", rsiTop, rsiBottom);
        } else {
          this.priceScaleMethod(series["name"], scaleId, top, bottom);
        }
      });
    };
    if (macdChecked && rsiChecked) {
      applyPriceScale(priceScaleObj["MACD"].series, "macd", 0.6, 0.2);
      applyPriceScale(
        priceScaleObj["RSI"].series,
        "macdrsi",
        0.1,
        0.5,
        0.8,
        0.05
      );
      this.priceScaleMethod(chartContainer, "right", 0.1, 0.5);
    } else if (macdChecked && !rsiChecked) {
      applyPriceScale(priceScaleObj["MACD"].series, "macd", 0.6, 0.1);
      this.priceScaleMethod(chartContainer, "right", 0.1, 0.5);
    } else if (!macdChecked && rsiChecked) {
      applyPriceScale(
        priceScaleObj["RSI"].series,
        "macdrsi",
        0.2,
        0.45,
        0.7,
        0.05
      );
      this.priceScaleMethod(chartContainer, "right", 0.1, 0.4);
    } else if (!macdChecked && !rsiChecked) {
      this.priceScaleMethod(chartContainer, "right", 0.1, 0.3);
    }
  }
  priceScaleMethod(series, scaleId, top, bottom) {
    series.priceScale(scaleId).applyOptions({
      scaleMargins: {
        top: top,
        bottom: bottom,
      },
    });
  }
  displayCheckStatus(chartTabIndex, checkedList, fetchList) {
    // let isHeikin = checkedList.includes("HEI");
    // let allChecked = checkedList.includes("All");
    // let macdChecked = checkedList.includes('MACD')

    let includeLength = checkedList.filter(
      (chk) => chk == "RSI" || chk == "MACD"
    ).length;

    let aoSeries = this.getSeries(fetchList, "AO").series[0].name;

    // rsi,macd,ao series display status
    // if (allChecked) {
    // aoSeries.setData([]);
    // }

    if (includeLength > 0) {
      aoSeries.setData([]);
    } else {
      // isHeikin ? aoSeries.setData(this.aoHei) : aoSeries.setData(this.ao);
      aoSeries.setData(this.ao);
    }
  }
  getSeries(obj, id) {
    return obj.find((el) => el.key == id);
  }

  async getFlagTrend(checkedList, chartObj, kind) {
    let { url, series, key } = chartObj;

    // console.log('series',series);
    let initLoad = await this.isInitLoad(series, false, key);

    let trendSeries = series[0].name;
    // console.log('getIndicator','isInitLoad',initLoad,key);
    if (initLoad) {
      // let transformUrl =this.setRequestUrl(isHeikin,key,url);
      let transformUrl = url;
      let data = await fetchUrl(transformUrl, kind);

      let result = data.map(({ time, value, color }) => ({
        time,
        value: value * 1.005,
        ...this.getFlagColor(color),
      }));
      this.trend_hei = result;
      // console.log("trend_hei", this.trend_hei);
    }

    let trend1Checked = checkedList?.includes("TREND1");

    trendSeries.setData([]);
    if (trend1Checked) {
      trendSeries.setData(this["trend_hei"]);
    }
  }

  getFlagColor(colorNum) {
    if (colorNum == 1) {
      // blue
      return {
        topColor: "rgb(1 73 23 / 30%)",
        bottomColor: "rgb(1 73 23 / 7%)",
      };
    } else if (colorNum == -1) {
      return {
        topColor: "rgba(255, 0, 0, 0.2)",
        bottomColor: "rgba(255, 0, 0, 0.0)",
      };
    } else {
      return {
        topColor: "transparent",
        bottomColor: "transparent",
      };
    }
  }

  async getSmartLineData(kind, pmChart, checked, id, forceUpdate = false) {
    const upperOption = {
      title: "upper Line",
      lineWidth: 1.5,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "white",
    };

    const lowerOption = {
      title: "lower Line",
      lineWidth: 1.5,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "white",
    };

    const middleOption = {
      title: "middle Line",
      lineWidth: 1.5,
      priceScaleId: "right",
      priceFormat: {
        type: "price",
        precision: 5,
        minMove: 0.00001,
      },
      color: "white",
    };

    try {
      // if (!this.lineData) {
      //   this.lineData = await getSmartLineTest(kind);
      // }

      // if (!this.lineData || forceUpdate) {
      //   this.lineData = await getSmartLineTest(kind);
      // }

      if (!this.lineDataMap[kind] || forceUpdate) {
        this.lineDataMap[kind] = await getSmartLineTest(kind);
      }
      const lineData = this.lineDataMap[kind];

      if (id === "FILLED") {
        if (!this.filledData || forceUpdate) {
          this.filledData = await getFilledLineTest(kind);
        }
      }

      const upperLowerlineOptions = [
        { key: "upper_line", option: upperOption },
        { key: "lower_line", option: lowerOption },
      ];

      const middlelineOptions = [{ key: "middle_line", option: middleOption }];

      if (id == "UPPERLOWER") {
        if (checked) {
          // 기존 시리즈 삭제
          this.upper_lower.forEach(({ series }) =>
            pmChart.removeSeries(series)
          );
          this.upper_lower = [];

          upperLowerlineOptions.forEach(({ key, option }) => {
            const series = pmChart.addLineSeries(option);
            let data = lineData[key].map((line) => ({
              value: line.value,
              time: line.time,
            }));
            // 중복 제거
            data = Array.from(
              new Map(data.map((item) => [item.time, item])).values()
            );

            this.upper_lower.push({ series, data: data });
            series.setData(data);
          });
          // this.fetchData = true;
        } else {
          this.upper_lower.forEach(({ series }) => {
            series.setData([]);
          });
        }
      } else if (id == "MIDDLE") {
        if (checked) {
          this.middle.forEach(({ series }) => pmChart.removeSeries(series));
          this.middle = [];

          middlelineOptions.forEach(({ key, option }) => {
            const series = pmChart.addLineSeries(option);
            let data = lineData[key].map((line) => ({
              value: line.value,
              time: line.time,
            }));

            // 중복 제거
            data = Array.from(
              new Map(data.map((item) => [item.time, item])).values()
            );

            this.middle.push({ series, data: data });
            series.setData(data);
          });
        } else {
          this.middle.forEach(({ series }) => {
            series.setData([]);
          });
        }
      } else if (id == "FILLED") {
        if (!this.filledData) {
          this.filledData = await getFilledLineTest(kind);
        }
        if (checked) {
          this.filled.forEach(({ hlcSeries }) =>
            pmChart.removeSeries(hlcSeries)
          );
          this.filled = [];

          // const filledList = await getFilledLineTest(kind);
          // HLCAreaSeries를 사용하여 HLC 영역 시리즈 추가
          const filledList = this.filledData;
          const hlcSeriesView = new HLCAreaSeries();
          const hlcSeries = pmChart.addCustomSeries(hlcSeriesView);

          const firstLine = filledList.first_line;
          const secondLine = filledList.second_line;

          let hlcData = firstLine.map((point, index) => {
            const high = Math.max(point.value, secondLine[index].value);
            const low = Math.min(point.value, secondLine[index].value);

            return {
              time: point.time,
              high: high, // 더 큰 값
              low: low, // 더 작은 값
              close: secondLine[index].value,
            };
          });

          // 중복 제거
          hlcData = Array.from(
            new Map(hlcData.map((item) => [item.time, item])).values()
          );

          this.filled.push({ hlcSeries, data: hlcData });

          hlcSeries.setData(hlcData);
        } else {
          this.filled.forEach(({ hlcSeries }) => {
            hlcSeries.setData([]);
          });
        }
      } else if (id == "SMARTCHANNEL") {
        if (!this.filledData) {
          this.filledData = await getFilledLineTest(kind);
        }

        if (checked) {
          // 기존 시리즈 삭제
          this.upper_lower.forEach(({ series }) =>
            pmChart.removeSeries(series)
          );
          this.upper_lower = [];

          upperLowerlineOptions.forEach(({ key, option }) => {
            const series = pmChart.addLineSeries(option);
            let data = lineData[key].map((line) => ({
              value: line.value,
              time: line.time,
            }));
            // 중복 제거
            data = Array.from(
              new Map(data.map((item) => [item.time, item])).values()
            );

            this.upper_lower.push({ series, data: data });
            series.setData(data);
          });
          // this.fetchData = true;

          this.filled.forEach(({ hlcSeries }) =>
            pmChart.removeSeries(hlcSeries)
          );
          this.filled = [];

          // const filledList = await getFilledLineTest(kind);
          // HLCAreaSeries를 사용하여 HLC 영역 시리즈 추가
          const filledList = this.filledData;
          const hlcSeriesView = new HLCAreaSeries();
          const hlcSeries = pmChart.addCustomSeries(hlcSeriesView);

          const firstLine = filledList.first_line;
          const secondLine = filledList.second_line;

          let hlcData = firstLine.map((point, index) => {
            const high = Math.max(point.value, secondLine[index].value);
            const low = Math.min(point.value, secondLine[index].value);

            return {
              time: point.time,
              high: high, // 더 큰 값
              low: low, // 더 작은 값
              close: secondLine[index].value,
            };
          });

          // 중복 제거
          hlcData = Array.from(
            new Map(hlcData.map((item) => [item.time, item])).values()
          );

          this.filled.push({ hlcSeries, data: hlcData });

          hlcSeries.setData(hlcData);

          // hlcSeries.priceScale("rightSide").applyOptions({
          //   scaleMargins: {
          //     top: 0.2,
          //     bottom: 0.3,
          //   },
          // });
        } else {
          this.upper_lower.forEach(({ series }) => {
            series.setData([]);
          });
          this.filled.forEach(({ hlcSeries }) => {
            hlcSeries.setData([]);
          });
        }
      }
      // }
    } catch (error) {
      console.error("line 오류", error);
    }
  }
}
